export function animations() {
    $( document ).ready(function() {
        $('.section-intro .logo-inner').css('transform','scaleX(1) translateX(0)');

        setTimeout(function(){
            $('.section-intro .logo-inner img').css('opacity','1');
        }, 900);
        setTimeout(function(){
            $('.intro-right .text-inner').css('opacity','1');
        }, 1500);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/animations.js